import { ProgressSpinner } from "primereact/progressspinner";
import { columnSettings } from "./report-template-setting";

const MobileList = ({ listData, loading, groupNames, groupMap }) => {
    const groups = {};
    listData.forEach((row) => {
        const key = row.group_label || row.data_kendaraan?.nomor_polisi || "-";
        if (!groups[key]) groups[key] = [];
        groups[key].push(row);
    });

    const settings = {};
    for (let column of columnSettings) {
        settings[column.field] = column;
    }

    const totalMasalah = groupNames?.reduce(
        (sum, name) => sum + (groupMap[name]?.group_count || 0),
        0
    );

    return (
        <div className="flex flex-col gap-4 p-4 w-full">
            {loading && (
                <div className="flex justify-center">
                    <ProgressSpinner />
                </div>
            )}

            {!loading && Object.keys(groups).length === 0 && (
                <p className="text-center text-slate-500">No data available</p>
            )}

            {/* Grouped detail cards */}
            {!loading &&
                Object.keys(groups).map((key) => {
                    const groupRows = groups[key];
                    const groupData = groupRows[0].group_data || groupRows[0].data_kendaraan;

                    return (
                        <div
                            key={groupData.nomor_polisi}
                            className="bg-zinc-50 rounded-xl shadow-sm border border-zinc-200 overflow-hidden"
                        >
                            {/* Group header */}
                            <div className="bg-indigo-100 px-4 py-2 font-semibold text-indigo-800 border-b border-zinc-200">
                                {groupData.nomor_polisi}
                            </div>

                            {/* Detail rows */}
                            {groupRows
                                .filter((row) => row.report_type === "detail")
                                .map((row, index) => (
                                    <div
                                        key={row.mykey ?? index}
                                        className="px-4 py-2 border-b border-zinc-200 bg-white"
                                    >
                                        {columnSettings
                                            .filter((col) => col.field !== "no")
                                            .map((col) => {
                                                let value = row[col.field];

                                                if (col.type === "number" && value !== null && value !== undefined) {
                                                    value = value.toLocaleString("id-ID");
                                                } else if (col.type === "date" && value) {
                                                    value = new Date(value).toLocaleDateString("id-ID", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                    });
                                                } else if (value === null || value === undefined) {
                                                    value = "-";
                                                } else if (typeof value === "object" && value?.nama) {
                                                    value = value.nama;
                                                }

                                                if (col.field === "keterangan") {
                                                    return (
                                                        <div key={col.field} className="flex flex-col mb-1">
                                                            <span className="text-slate-600 font-bold">{col.name}:</span>
                                                            <span className="text-slate-800">{value}</span>
                                                        </div>
                                                    );
                                                }

                                                return (
                                                    <div className="row-between-start mb-1" key={col.field}>
                                                        <span className="text-slate-600 font-bold">{col.name}:</span>
                                                        <span className="text-slate-800">{value}</span>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                ))}

                            {/* Group footer */}
                            {(() => {
                                const details = groupRows.filter((row) => row.report_type === "detail");

                                const totalJumlah = details.reduce((sum, item) => sum + (item.jumlah ?? 0), 0);
                                const totalHarga = details.reduce((sum, item) => sum + (item.total_harga ?? 0), 0);

                                // KM calculation
                                let selisihKm = "-";
                                if (details.length >= 2) {
                                    const kms = details.map((item) => item.speedo_akhir).filter(Boolean);
                                    const minKm = Math.min(...kms);
                                    const maxKm = Math.max(...kms);
                                    selisihKm = (maxKm - minKm).toLocaleString("id-ID");
                                }

                                return (
                                    <div className="px-4 py-3 bg-indigo-50 text-indigo-900 font-semibold border-t border-indigo-200">
                                        <div className="flex justify-between">
                                            <span>Total Jumlah (Ltr):</span>
                                            <span>{totalJumlah.toLocaleString("id-ID")}</span>
                                        </div>

                                        <div className="flex justify-between">
                                            <span>Total Harga:</span>
                                            <span>Rp. {totalHarga.toLocaleString("id-ID")}</span>
                                        </div>

                                        <div className="flex justify-between">
                                            <span>Selisih KM:</span>
                                            <span>{selisihKm}</span>
                                        </div>
                                    </div>
                                );
                            })()}

                        </div>
                    );
                })}
        </div>
    );
};

export default MobileList;
